module.exports = __webpack_public_path__ + "static/simulators-4b0733f17735e6b0be1b7058c6cec546.mp4";